import React, { useState, useEffect, memo, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import Swiper from 'react-id-swiper';
import 'swiper/css/swiper.css';
import '../../../node_modules/video-react/dist/video-react.css';
import { Player, ControlBar, BigPlayButton, Shortcut } from 'video-react';

import { hasClass } from '../../utils/utils';
import Preview from '../../components/Preview/Preview';
import { logging } from '../../actions/log';

import styles from './SoftDetailSwiper.module.less';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(({ swiperData, appDetailsData }) => {
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);

  const swiperEl = useRef(null);
  const [player, setPlayer] = useState(null);
  const [showPreview, setShowPreview] = useState(false);
  const [activeImageIndex, setActiveImageIndex] = useState(null);
  const [swiperParams, setSwiperParams] = useState(null);

  const [prevClass, setPrevClass] = useState(styles.detail_swiper_prev_disable);
  const [nextClass, setNextClass] = useState(styles.detail_swiper_next);

  useEffect(() => {
    if (player && player.actions) {
    }
  }, [player]);

  useEffect(() => {
    if (swiperData && appDetailsData) {
      const params = {
        slidesPerView: 'auto',
        spaceBetween: 20,
        autoplay: false,
        on: {
          click(e = {}) {
            if (!e.target) {
              return;
            }
            if (e.target.hasAttribute('data-index')) {
              setActiveImageIndex(e.target.getAttribute('data-index'));
              setShowPreview(true);
            }
            if (hasClass(e.target, 'video-react-video')) {
              setActiveImageIndex('0');
              setShowPreview(true);
            }
            dispatch(
              logging({
                category: 'C',
                action: 'AppDetail_Show_big',
                label: '',
                param2: {
                  source: 'AppDetail',
                  source_p: logInfoData.source_p,
                  source_pp: logInfoData.source_pp,
                  softid: appDetailsData.softID,
                  softType: '0',
                  type: hasClass(e.target, styles.detail_swiper_img) ? 'img' : 'video',
                },
                param3: appDetailsData.bizInfo,
              }),
            );
          },
        },
      };
      setSwiperParams(params);
    }
  }, [appDetailsData, logInfoData]);

  const goNext = () => {
    const swiper = swiperEl.current && swiperEl.current.swiper;
    if (swiper) {
      swiper.slideNext();
      if (swiper.slides.length - 3 === swiper.activeIndex) {
        setPrevClass(styles.detail_swiper_prev);
        setNextClass(styles.detail_swiper_next_disable);
      } else {
        setPrevClass(styles.detail_swiper_prev);
        setNextClass(styles.detail_swiper_next);
      }
    }
  };
  const goPrev = () => {
    const swiper = swiperEl.current && swiperEl.current.swiper;
    if (swiper) {
      swiper.slidePrev();
      if (swiper.activeIndex === 0) {
        setPrevClass(styles.detail_swiper_prev_disable);
        setNextClass(styles.detail_swiper_next);
      } else {
        setPrevClass(styles.detail_swiper_prev);
        setNextClass(styles.detail_swiper_next);
      }
    }
  };

  return (
    <>
      <div className={styles.detail_swiper}>
        {swiperParams && (
          <Swiper {...swiperParams} ref={swiperEl}>
            {swiperData &&
              swiperData.map((item, i) => (
                <div className={styles.detail_swiper_slide} key={i} data-index={i}>
                  {item.type === '1' && (
                    <div className={styles.video_play} data-index={i}>
                      <div
                        className={`iconfont icon-v_stop ${styles.video_play_btn}`}
                        data-index={i}
                      />
                    </div>
                  )}
                  {item.type === '1' ? (
                    <Player
                      src={`${item.url}`}
                      ref={p => setPlayer(p)}
                      poster={item.videoImg}
                      className={styles.detail_swiper_video}
                      fluid={false}
                      playsInline={true}
                      autoPlay={false}
                      muted={true}
                      loop={true}
                      width={`100%`}
                      height={`100%`}
                    >
                      <Shortcut clickable={false} dblclickable={false} />
                      <BigPlayButton position="center" className={styles.player_btn} />
                      <ControlBar
                        autoHide={false}
                        disableCompletely={true}
                        disableDefaultControls={true}
                      ></ControlBar>
                    </Player>
                  ) : (
                    <img
                      className={styles.detail_swiper_img}
                      src={item.url}
                      alt=""
                      data-index={i}
                    />
                  )}
                </div>
              ))}
          </Swiper>
        )}
        {swiperData && swiperData.length > 3 && <div className={prevClass} onClick={goPrev} />}
        {swiperData && swiperData.length > 3 && <div className={nextClass} onClick={goNext} />}
        <Preview
          data={swiperData}
          visible={showPreview}
          activeIndex={activeImageIndex}
          close={setShowPreview}
        />
      </div>
    </>
  );
});
